import {
    Component,
    ComponentRef,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    Type,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';

import { DashboardPanelInterface } from '@models/dashboard-panel-interface';
import { DashboardPanelFactoryService } from '@service/dashboard-panel-factory-service';
import { DashboardPanelParameters } from 'ops/common/models/dashboard-panel-parameters';

@Component({
    selector: 'app-dashboard-panel',
    templateUrl: './dashboard-panel.component.html',
    styleUrls: ['./dashboard-panel.component.scss'],
    standalone: false
})
export class DashboardPanelComponent implements OnChanges {
    @ViewChild('container', { read: ViewContainerRef, static: true })
    container: ViewContainerRef;

    @Output() onAddPanelClicked = new EventEmitter<DashboardPanelComponent>();
    @Output() onDeleteClicked = new EventEmitter<DashboardPanelComponent>();
    @Output() onResourceNotFound = new EventEmitter<DashboardPanelParameters>();
    @Output() onInvalidPanelType = new EventEmitter<DashboardPanelParameters>();
    @Input() panelParameters: DashboardPanelParameters = null;

    component: ComponentRef<DashboardPanelInterface> = null;
    _isResourceNotFound = false;

    constructor(private panelFactory: DashboardPanelFactoryService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.panelParameters) {
            this.destroyComponent();

            if (this.panelParameters) {
                let panelType: Type<DashboardPanelInterface>;

                try {
                    panelType = this.panelFactory.getPanel(this.panelParameters);
                } catch (err) {
                    this.emitInvalidPanelType();
                    return;
                }

                let component = this.container.createComponent<DashboardPanelInterface>(panelType);

                this._isResourceNotFound = false;
                this.component = component;
                this.container.element.nativeElement.appendChild(component.location.nativeElement);

                for (const i in this.panelParameters.params) {
                    component.instance[i] = this.panelParameters.params[i];
                }

                this.bindEvents(component);
            }
        }
    }

    emitInvalidPanelType() {
        this.onInvalidPanelType.emit(this.panelParameters);
    }

    bindEvents(component: ComponentRef<any>) {
        component.instance.onDeleteClicked?.subscribe(() => this.handleDeleteClicked());
        component.instance.onResourceNotFound?.subscribe(() => {
            this.handlePanelResourceNotFound();
        });
    }

    handleDeleteClicked() {
        this.emitDelete();
    }

    emitDelete() {
        this.onDeleteClicked.emit(this);
    }

    handlePanelResourceNotFound() {
        this._isResourceNotFound = true;

        this.destroyComponent();
        this.emitResourceNotFound();
    }

    destroyComponent() {
        if (this.component) {
            this.component.destroy();
            this.component.location.nativeElement.remove();
            this.component = null;
        }
    }

    emitResourceNotFound() {
        this.onResourceNotFound.emit(this.panelParameters);
    }

    handleAddPanelClicked() {
        this.emitAddPanelClicked();
    }

    emitAddPanelClicked() {
        this.onAddPanelClicked.emit(this);
    }

    handleCloseErrorMessageClicked(event: MouseEvent) {
        event.stopPropagation();
        this._isResourceNotFound = false;
    }

    public get isNullPanel() {
        return this.component === null;
    }
    public get isResourceNotFound() {
        return this._isResourceNotFound;
    }
}
